import { render, staticRenderFns } from "./WorldDatePicker.vue?vue&type=template&id=452645db&scoped=true&"
import script from "./WorldDatePicker.vue?vue&type=script&lang=js&"
export * from "./WorldDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./WorldDatePicker.vue?vue&type=style&index=0&id=452645db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452645db",
  null
  
)

export default component.exports